import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import * as Icons from "@ant-design/icons-vue";
import "ant-design-vue/dist/reset.css";
import "../src/assets/base.css";
import { createI18n } from "vue-i18n";

import LangCN from "../src/language/zh-cn";
import LangEN from "../src/language/en";
import LangRUS from "../src/language/rus";

const i18n = createI18n({
  globalInjection: true, // 全局生效$t
  legacy: false,
  locale: "zh-cn",
  messages: {
    "zh-cn": LangCN,
    en: LangEN,
    ru: LangRUS,
  },
});
const app = createApp(App);

Object.keys(Icons).map((key) => {
  app.component(key, Icons[key as keyof typeof Icons]);
});

app.use(i18n);
app.use(store);
app.use(router);
app.use(Antd);
app.use(ElementPlus);
app.mount("#app");
